import { useCallback, useRef } from 'react'
import { useResizeObserver } from '../../../hooks'
import type { VirtualScrollItemStyle } from '../../VirtualScroll'

function useHeightObserver({
  style,
  onChangeSize,
}: {
  style?: VirtualScrollItemStyle
  onChangeSize?: (height: number) => void
}) {
  const localRef = useRef<HTMLDivElement>(null)
  const heightRef = useRef<number | null>(null)

  if (style?.height) {
    const height = parseFloat(style.height)
    heightRef.current = height
  }

  const handleSizeChange = useCallback(
    (height: number | undefined) => {
      if (!onChangeSize || !height) return

      const roundedHeight = Math.round(height)
      if (typeof heightRef.current === 'number' && heightRef.current > 0 && roundedHeight !== heightRef.current) {
        onChangeSize(roundedHeight)
        heightRef.current = roundedHeight
      }
    },
    [onChangeSize]
  )

  useResizeObserver({
    ref: localRef,
    box: 'border-box',
    onResize: ({ height }) => handleSizeChange(height),
  })

  return localRef
}

export default useHeightObserver
